import { helper } from '@ember/component/helper';

export default helper(function latLngHelper([ latLng ]) {
  let result = '';
  if (latLng && latLng.length === 2) {
    result = `(${latLng.join(', ')})`;
  }
  return result;
});
